import { Box, Stack, Button } from '@mui/material';
import { useTranslations } from 'next-intl';

const filters = {
    checkinBaggage: 'Check-in luggage',
    seat: 'Free seat selection',
    meal: 'Free meal selection',
};

export const Filters = ({
    selectedFilters,
    onFilterChange,
}: {
    selectedFilters: string[];
    onFilterChange: (label: string, checked: boolean) => void;
}) => {
    const tFareFamily = useTranslations('fareFamily');
    return (
        <Box
            sx={{
                display: 'flex',
                overflowX: 'auto',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                '&::-webkit-scrollbar': { display: 'none' },
            }}
        >
            <Stack direction="row" spacing={1}>
                {Object.entries(filters).map(([key, value]) => {
                    const isSelected = selectedFilters.includes(key);

                    return (
                        <Button
                            key={key}
                            onClick={() => onFilterChange(key, !isSelected)}
                            variant="outlined"
                            size="small"
                            sx={(theme) => ({
                                borderRadius: '24px',
                                textTransform: 'none',
                                fontWeight: 500,
                                fontSize: '0.68rem',
                                whiteSpace: 'nowrap',
                                backgroundColor: isSelected ? theme.palette.primary.main : '#fff',
                                borderColor: isSelected ? theme.palette.primary.main : '#ccc',
                                color: isSelected ? '#fff' : theme.palette.primary.main,
                                '&:hover': {
                                    backgroundColor: isSelected
                                        ? theme.palette.primary.dark
                                        : theme.palette.action.hover,
                                },
                            })}
                        >
                            {tFareFamily(value)}
                        </Button>
                    );
                })}
            </Stack>
        </Box>
    );
};